import { render, staticRenderFns } from "./manpowers.vue?vue&type=template&id=dfd95e32"
import script from "./manpowers.ts?vue&type=script&lang=js&external"
export * from "./manpowers.ts?vue&type=script&lang=js&external"
import style0 from "./manpowers.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports